import { useCallback } from "react";

import { useAuthProvider, useNotify } from "react-admin";
import { defaultAuthParams } from "ra-core/lib/auth/useAuthProvider";
import { useLocation, useHistory } from "react-router-dom";

const useReset = () => {
    const authProvider = useAuthProvider();
    const location = useLocation();
    const locationState = location.state;
    const notify = useNotify();
    const history = useHistory();
    const nextPathName = locationState && locationState.nextPathname;

    const reset = useCallback(
        (params = {}, pathName = defaultAuthParams.loginUrl) =>
            authProvider
                .reset(params)
                .then((ret) => {
                    history.push(nextPathName || pathName);
                    notify("auth.resetSuccess", "info");
                    return ret;
                })
                .catch((error) => {
                    notify(error?.message || "auth.resetFailure", "error");
                }),
        [authProvider, history, nextPathName, notify]
    );

    const resetWithoutProvider = useCallback(
        (_, __) => {
            history.push(defaultAuthParams.loginUrl);
            return Promise.resolve();
        },
        [history]
    );

    return authProvider ? reset : resetWithoutProvider;
};

export default useReset;
